export const SetCookieExpMS = (str, ms, cookieName) => {
	var date = new Date();
	date.setTime(ms);
	var domain = `domain=.${_.config.GetSchemeDomain("cookie")}`;
	var secureString = "; secure";
	if (document.location.protocol == "http:") secureString = "";
	document.cookie = `${cookieName}=${str};expires=${date.toGMTString()};path=/;${domain}${secureString}`;
};

export const GetCookieValue = (name) => {
	var nameEQ = name + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ")
			// get rid of leading spaces
			c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
	}
	return null;
};

export const SetCookie = (str, days, cookieName) => {
	var date = new Date();
	SetCookieExpMS(str, date.getTime() + days * 24 * 60 * 60 * 1000, cookieName);
};

export const RemoveCookie = (cookieName) => {
	SetCookie("", -7, cookieName);
};
